//#region Asset Imports

import * as moment from 'moment'
import * as _ from 'underscore'

//#endregion

//#region DevExtreme Imports

import DevExpress from 'devextreme'

//#endregion

//#region Imports

import { Api } from '../../api/api.module'
import { SchemaModel, SchemaElement, SchemaElementApperance } from '../../api/api.models'
import { CommonHelper } from '../../../helpers/common-helper'
import { Md5 } from '../../../helpers/md5-helper'
import { EventsNames } from '../../../helpers/events-names'
import { ThemeHelper } from '../../../helpers/theme-helper'
import { Dictionary, IUserSession, LocalizationHelper, ToastHelper, TypeHelper } from '../../../helpers'
import { Enums } from '../../../models/common'
import { IReferenceType } from '../../../models/util/interfaces'
import { IMRBaseControlDirectiveController } from '../base'
import { OpData, OpDataType, OpLocation } from '../../../models/core'
import { OpSchema } from '../../../models/custom'

//#endregion

interface SchemaSource {
	id?: number // id for location tab only!!!
	data?: SchemaModel
	isReadOnly: boolean
}

interface ImagePosition {
	top: number
	left: number
}

interface SchemaButton extends DevExpress.ui.dxButtonOptions {
	schemaNumber: number
	value: string
	cssClass: string
	image: number[]
}

interface SchemaScope extends ng.IScope {
	id: any
	source: SchemaSource
	schemaOwner: any
	schemaModel: SchemaModel
	isLoaded: boolean
	formOptions: DevExpress.ui.dxFormOptions
	formData: any
	items: any[]
	gotoBtns: any[]

	applyButtonOptions: DevExpress.ui.dxButtonOptions
	isApplyButtonDisabled: boolean

	NO_SCHEMA_TEXT: string
}

type EditorType =
	| 'dxAutocomplete'
	| 'dxCalendar'
	| 'dxCheckBox'
	| 'dxColorBox'
	| 'dxDateBox'
	| 'dxDropDownBox'
	| 'dxHtmlEditor'
	| 'dxLookup'
	| 'dxNumberBox'
	| 'dxRadioGroup'
	| 'dxRangeSlider'
	| 'dxSelectBox'
	| 'dxSlider'
	| 'dxSwitch'
	| 'dxTagBox'
	| 'dxTextArea'
	| 'dxTextBox'

export class SchemaDirectiveController extends IMRBaseControlDirectiveController {
	private previousModelMd5: string
	private requestFailed: boolean = false
	private form: JQueryDeferred<DevExpress.ui.dxForm>
	private lastResizeTimeout: any
	private num: number = 0
	private originalHeight: number
	private originalWidth: number
	private imgPosition: ImagePosition
	private scaleX: number
	private scaleY: number

	constructor(private readonly $scope: SchemaScope, private readonly $element: JQuery, private readonly api: Api, private readonly userSession: IUserSession) {
		super()

		this.onClear()
		this.setOptions()
		this.setEvents()
		this.loadSchema()
	}

	//#region Events

	private setEvents(): void {
		this.$scope.$watch(
			() => {
				return this.$element.width() * this.$element.height()
			},
			(width: number) => {
				this.resize()
			}
		)

		this.$scope.$on(EventsNames.UPDATE_SCHEMAS, () => {
			if (this.$scope.source.id > 0) {
				this.userSession
					.getDataProvider()
					.Location.getLocationSchemas(this.$scope.source.id)
					.then((schemas: OpSchema[]) => {
						if (_.size(schemas) > 0) {
							this.updateSchema(CommonHelper.opSchemaToSchemaModel(schemas[0], this.userSession))
						} else {
							this.updateSchema(null)
						}
					})
				//#region remove is everything on wuth api
				// this.api.location.getSchema(this.$scope.source.id).then((result: SchemaModel) => {
				//     console.log('result: SchemaModel', result)
				//     this.updateSchema(result)
				// })
				//#endregion
			}
		})
	}

	private onClear(): void {
		if (this.$scope.id == null) {
			this.$scope.id = Date.now()
		}

		this.$scope.items = []
		this.$scope.gotoBtns = []
		this.$scope.formData = {}
		this.$scope.isApplyButtonDisabled = true
		this.form = $.Deferred<DevExpress.ui.dxForm>()
	}

	private onApplyButtonClick(): void {
		const location: OpLocation = new OpLocation(null)
		location.idLocation = this.$scope.source.id
		location.opState = Enums.OpChangeState.Modified

		Object.keys(this.$scope.formData).forEach((prop: string) => {
			const data: OpData = new OpData(null)
			data.idDataType = parseInt(prop)
			data.value = this.$scope.formData[prop]
			data.opState = Enums.OpChangeState.Modified

			location.dataList.push(data)
		})

		const currentMd5: string = Md5.init(location)

		if (this.previousModelMd5 !== currentMd5 || this.requestFailed) {
			this.previousModelMd5 = currentMd5

			this.userSession
				.getDataProvider()
				.Location.saveLocation(location)
				.then((result: OpLocation) => {
					if (result == null) {
						ToastHelper.showError(LocalizationHelper.getLocalizedText('SchemaSaveError', { collection: 'Popup' }))
						this.requestFailed = true
					} else {
						ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SchemaSaved))
						this.$scope.isApplyButtonDisabled = true
						this.requestFailed = false
					}
				})
				.catch(() => {
					this.requestFailed = true
				})
		}

		//#region remove if everything ok with ne saving
		// const model: FormValuesModel = <FormValuesModel>{}
		// model.fields = []
		// model.id = this.$scope.source.id

		// Object.keys(this.$scope.formData).forEach((prop: string) => {
		//     const field: FieldNameValueModel = new FieldNameValueModel()
		//     field.idDataType = parseInt(prop)
		//     field.value = this.$scope.formData[prop]

		//     model.fields.push(field)
		// })

		// const currentMd5: string = Md5.init(model)

		// if (this.previousModelMd5 !== currentMd5 || this.requestFailed) {
		//     this.previousModelMd5 = currentMd5

		//     this.api.location.saveLocation(model).then((result: LocationModel) => {
		//         console.log('result: LocationModel', result)
		//         if (result == null) {
		//             ToastHelper.showError(LocalizationHelper.getLocalizedText('SchemaSaveError', { collection: 'Popup' }))
		//             this.requestFailed = true
		//         } else {
		//             ToastHelper.showSuccess(LocalizationHelper.getLocalizedText(LocalizationHelper.Text.SchemaSaved))
		//             this.$scope.isApplyButtonDisabled = true
		//             this.requestFailed = false
		//         }
		//     }).catch(() => {
		//         this.requestFailed = true
		//     })
		// }
		//#endregion
	}

	//#endregion

	//#region Setup

	private setOptions(): void {
		this.$scope.NO_SCHEMA_TEXT = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NoSchema)

		this.setFormOptions()
		this.setApplyButtonOptions()
	}

	private setFormOptions(): void {
		this.$scope.formOptions = {
			alignItemLabels: false,
			alignItemLabelsInAllGroups: false,
			bindingOptions: {
				formData: 'formData',
				items: 'items',
			},
			onInitialized: (e: any) => {
				this.form.resolve(e.component)
			},
		}
	}

	private setApplyButtonOptions(): void {
		this.$scope.applyButtonOptions = {
			text: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Apply),
			bindingOptions: {
				disabled: 'isApplyButtonDisabled',
			},
			onClick: (e: any) => {
				this.onApplyButtonClick()
			},
		}
	}

	private updateScale(height: number, width: number): void {
		this.originalHeight = height
		this.originalWidth = width

		const actualImg: JQuery<HTMLElement> = this.$element.find('.schema')

		if (actualImg != null) {
			this.scaleX = actualImg.width() / this.originalWidth
			this.scaleY = actualImg.height() / this.originalHeight
			this.imgPosition = actualImg.position()
		}
	}

	private getImageSize(byteArray): JQueryPromise<void> {
		const deferred: JQueryDeferred<void> = $.Deferred<void>()
		const img: HTMLImageElement = new Image()

		img.onload = (): void => {
			this.updateScale(this.originalHeight, this.originalWidth)
			deferred.resolve()
		}

		img.src = 'data:image/png;base64,' + byteArray

		return deferred.promise()
	}

	private formatDebugHint(item: SchemaElement): string {
		const idDatatype: number = item.idDataType
		const hint: string = 'IdDataType = ' + (idDatatype || 'no') + ' | ' + 'XxY = ' + item.x + 'x' + item.y + ' | ' + 'WxH = ' + item.width + 'x' + item.height

		return hint
	}

	private checkCondition(elementApperance: SchemaElementApperance, currentValue: any): boolean {
		switch (elementApperance.condition) {
			case CommonHelper.greaterThan:
				if (currentValue > elementApperance.constraint1) {
					return true
				}
				break
			case CommonHelper.greaterOrEqual:
				if (currentValue >= elementApperance.constraint1) {
					return true
				}
				break
			case CommonHelper.lowerThan:
				if (currentValue < elementApperance.constraint1) {
					return true
				}
				break
			case CommonHelper.lowerOrEqual:
				if (currentValue <= elementApperance.constraint1) {
					return true
				}
				break
			case CommonHelper.equal:
				if (angular.equals(currentValue, elementApperance.constraint1)) {
					return true
				}
				break
			case CommonHelper.notEqual:
				if (currentValue != elementApperance.constraint1) {
					return true
				}
				break
			default:
				const str: string = elementApperance != null && elementApperance.condition != null ? elementApperance.condition.trim() : ''
				return _.size(str) === 0
		}
		return false
	}

	private changeBackgroundColor(input: JQuery, color: string): void {
		//input.find('label').find('.dx-field-item-label-text').css('color', color)
		input.find('input').css('background-color', color)

		input.find('.dx-checkbox').css('background-color', color)
	}

	private updateInputOnCheckCondition(elementApperance: SchemaElementApperance, input: JQuery, currentValue: any, isChanged: boolean = false): boolean {
		const result: boolean = this.checkCondition(elementApperance, currentValue)

		if (result == true) {
			this.changeBackgroundColor(input, elementApperance.color)
		} else if (isChanged == true) {
			//WHY we set WHITE color???????????
			this.changeBackgroundColor(input, '#fff')
		}

		return result
	}

	private updateInput(number: number, item: SchemaElement, curentValue: any): void {
		if (this.imgPosition != null) {
			const inputBox: JQuery<HTMLElement> = this.$element.find('.input-box' + '-' + this.$scope.id + '-' + number)

			inputBox.css({
				position: 'absolute',
				top: this.imgPosition.top + item.y * this.scaleY + 'px',
				left: this.imgPosition.left + item.x * this.scaleX + 'px',
				'font-size': item.height * this.scaleY + 'px',
				opacity: 1,
				height: item.height * this.scaleY + 'px',
			})

			inputBox.find('.dx-textbox').css({
				width: item.width * this.scaleX + 2 + 'px',
				height: item.height * this.scaleY + 2 + 'px',
			})

			inputBox.find('.dx-checkbox').css({
				width: item.height * this.scaleY + 2 + 'px',
				height: item.height * this.scaleY + 2 + 'px',
			})

			inputBox.find('img').css({
				width: item.width * this.scaleX + 'px',
				height: item.height * this.scaleY + 'px',
			})

			let isChanged: boolean = false
			item.elementsApperance.forEach((ea: SchemaElementApperance) => {
				isChanged = this.updateInputOnCheckCondition(ea, inputBox, curentValue, isChanged)
			})
		}
	}

	private updateItemPosition(number: number, item: SchemaElement): void {
		if (this.imgPosition != null) {
			const itemBox: JQuery<HTMLElement> = this.$element.find('.item-box' + '-' + this.$scope.id + '-' + number)

			itemBox.css({
				position: 'absolute',
				top: this.imgPosition.top + item.y * this.scaleY + 'px',
				left: this.imgPosition.left + item.x * this.scaleX + 'px',
				'font-size': item.height * this.scaleY + 'px',
				'line-height': '70%',
				width: item.width * this.scaleX + 2 + 'px',
				height: item.height * this.scaleY + 2 + 'px',
				opacity: 1,
			})

			itemBox.find('.dx-button-text').css({
				width: item.width * this.scaleX + 'px',
				height: item.height * this.scaleY + 'px',
				'font-size': item.height * this.scaleY * 0.6 + 'px',
			})
		}
	}

	private resize(): void {
		if (this.$scope.isLoaded == true) {
			if (this.lastResizeTimeout != null) {
				clearTimeout(this.lastResizeTimeout)
			}

			this.lastResizeTimeout = setTimeout(() => {
				const actualImg: JQuery<HTMLElement> = this.$element.find('.schema')

				this.scaleX = actualImg.width() / this.originalWidth
				this.scaleY = actualImg.height() / this.originalHeight
				this.imgPosition = actualImg.position()

				if (this.$scope.schemaModel != null && this.$scope.schemaModel.schemaConfiguration != null) {
					if (_.size(this.$scope.items) > 0) {
						this.$scope.items.forEach((input: any) => {
							const number: number = input.schemaNumber
							const sc: SchemaElement = this.$scope.schemaModel.schemaConfiguration[number]

							if (sc != null) {
								input.editorOptions.height = sc.height * this.scaleY + 2
								input.editorOptions.width = sc.width * this.scaleX + 2
							}

							this.updateInput(number, sc, this.$scope.formData[sc.idDataType])
						})
					}

					if (_.size(this.$scope.gotoBtns) > 0) {
						this.$scope.gotoBtns.forEach((btn: any) => {
							const number: number = btn.schemaNumber
							const sc: SchemaElement = this.$scope.schemaModel.schemaConfiguration[number]

							if (sc != null) {
								btn.height = sc.height * this.scaleY + 2
								btn.width = sc.width * this.scaleX + 2
							}

							this.updateItemPosition(number, sc)
						})
					}
				}
			}, 500)
		}
	}

	private addToForm(item: SchemaElement): void {
		if (item.idDataType != null && item.idDataType != undefined) {
			this.$scope.formData[item.idDataType] = item.value
		}

		this.addValidationRules(item, this.num++)
	}

	private addValidationRules(item: SchemaElement, number: number): void {
		switch (item.elementType) {
			case CommonHelper.SchemaElementType.Redirection:
				this.createButtonItem(number, item, (button) => {
					this.$scope.gotoBtns.push(button)
				})
				break
			default:
				switch (item.type) {
					case CommonHelper.integer:
						this.createInputItem('dxNumberBox', number, item, (input) => {
							input['validationRules'] = []
							input['validationRules'].push({
								type: 'pattern',
								pattern: '^[0-9]{0,}$',
								message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.IntegerField),
							})
							this.$scope.items.push(input)
						})

						break
					case CommonHelper.real:
						this.createInputItem('dxNumberBox', number, item, (input) => {
							input['validationRules'] = []
							input['validationRules'].push({
								type: 'numeric',
								message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.NumericField),
							})
							this.$scope.items.push(input)
						})
						break
					case CommonHelper.boolean:
						this.createInputItem('dxCheckBox', number, item, (input) => {
							input['validationRules'] = []
							input['validationRules'].push({
								type: 'boolean',
								message: LocalizationHelper.getLocalizedText(LocalizationHelper.Text.BooleanField),
							})
							this.$scope.items.push(input)
						})
						break
					case CommonHelper.string:
					default:
						this.createInputItem('dxTextBox', number, item, (input) => {
							this.$scope.items.push(input)
						})
						break
				}
		}
	}

	private createInputItem(editorType: EditorType, number: number, item: SchemaElement, callback: (input) => void): void {
		$.when(this.userSession.getDataProvider().DataType.getDataType(item.idDataType), this.getUnits()).then((dataType: OpDataType, unitDict: Dictionary<IReferenceType>) => {
			let unitName = TypeHelper.emptyString
			const unitId: number = dataType != null ? dataType.idUnit : 0

			if (item.isUnitVisible && unitId > 0) {
				const unit: IReferenceType = unitDict.tryGetValue(unitId)

				if (unit != null) {
					unitName = unit.toString()
				}
			}

			let description: string = TypeHelper.emptyString
			let labelLocation: 'left' | 'right' | 'top' = 'right'
			let showColon: boolean = false

			if (_.size(item.description) > 0) {
				description = item.description
				labelLocation = 'left'
				showColon = true
			}

			let fontColor: string = ThemeHelper.getTheme(this.userSession).defaultFontColor || '#000'
			let image: HTMLImageElement = null

			if (_.size(item.elementsApperance) > 0) {
				let conditionValue: any = item.value

				if (conditionValue == null || conditionValue == undefined) {
					conditionValue = {}
				}

				item.elementsApperance.forEach((ea: SchemaElementApperance) => {
					if (this.checkCondition(ea, conditionValue)) {
						if (_.size(ea.color) > 0) {
							fontColor = ea.color
						}

						if (_.size(ea.image) > 0) {
							const img: HTMLImageElement = new Image(item.width, item.height)
							img.src = 'data:image/png;base64,' + ea.image
							image = img
						}
					}
				})
			}

			let itemValue: string = TypeHelper.emptyString
			if (image != null) {
				itemValue = image.outerHTML
			} else {
				if (item.value != null) {
					const dataType: OpDataType = this.userSession.getDataProvider().DataType.getDataTypeLocal(item.idDataType)

					if (dataType != null && dataType.idDataTypeClass == Enums.DataTypeClass.Datetime && item.value.length > 2) {
						itemValue = moment(item.value).format(window['simax'].getDateTimeFormat('DATE_TIME_FORMAT_MOMENTJS', dataType.idDataType))
					} else if (dataType != null && dataType.idDataTypeClass == Enums.DataTypeClass.Date && item.value.length > 2) {
						itemValue = moment(item.value).format(window['simax'].getDateTimeFormat('DATE_FORMAT_MOMENTJS', dataType.idDataType))
					} else {
						itemValue = String(item.value)
					}
				} else {
					itemValue = '-'
				}
			}

			//!item.isEditable,
			const input /*: DevExpress.ui.dxFormSimpleItem extends....*/ = {
				schemaNumber: number,
				cssClass: 'input-box input-box' + '-' + this.$scope.id + '-' + number,

				dataField: item.idDataType + '',
				editorType: editorType,

				desciption: description,
				unitText: unitName,
				labelLocation: labelLocation,

				editorOptions: {
					width: item.width * this.scaleX + 2,
					height: item.height * this.scaleY + 2,
					hint: window['config'].DEBUG_SCHEMA == true ? this.formatDebugHint(item) : null,
					readOnly: true,
					value: item.value,
					onChange: (e: any) => {
						this.$scope.isApplyButtonDisabled = false
						const input: JQuery<HTMLElement> = this.$element.find('.input-box' + '-' + this.$scope.id + '-' + number)

						let isChanged: boolean = true
						item.elementsApperance.forEach((ea: SchemaElementApperance) => {
							isChanged = this.updateInputOnCheckCondition(ea, input, e.model.formData[item.idDataType], isChanged)
						})

						this.$scope.formData = e.model.formData
					},
				},
				label: {
					location: labelLocation,
					text: description + ' ' + unitName,
					showColon: showColon,
					visible: true,
				},
			}

			if (((this.$scope.source.isReadOnly || !item.isEditable) && editorType.indexOf('dxCheckBox') < 0) || item.valueHidden || image != null) {
				let valueHtml = TypeHelper.emptyString

				if (_.size(description) > 0) {
					if (itemValue.length > 0 && !item.valueHidden) {
						valueHtml = description + ' ' + unitName + ': ' + itemValue
					} else {
						valueHtml = description + ' ' + unitName
					}
				} else {
					if (itemValue.length > 0 && !item.valueHidden) {
						valueHtml = itemValue + ' ' + unitName
					} else {
						valueHtml = unitName
					}
				}

				const title: string = window['config'].DEBUG_SCHEMA == true ? 'title="' + this.formatDebugHint(item) + '"' : ''
				input['template'] = '<label style="color: ' + fontColor + '" ' + title + '>' + valueHtml + '</label>'
				input.label.visible = false
			}

			callback(input)
		})
	}

	private createButtonItem(number: number, item: SchemaElement, callback: (button) => void): void {
		let value: any = item.value

		if (value.search('CurrentObjectId') > 0) {
			const objectId: any = this.$scope.source.id
			value = value.replace('CurrentObjectId', objectId)
		}

		if (value.search('SchemaObjectId') > 0) {
			const objectId: number = <number>this.$scope.schemaModel.idObject
			value = value.replace('SchemaObjectId', objectId)
		}

		const button: SchemaButton = {
			schemaNumber: number,
			value: value,
			cssClass: 'goto-button item-box' + '-' + this.$scope.id + '-' + number,
			width: item.width * this.scaleX + 2,
			height: item.height * this.scaleY + 2,
			text: item.description,
			hint: window['config'].DEBUG_SCHEMA == true ? this.formatDebugHint(item) : item.description,
			onClick: (e: any) => {
				this.gotoAction(button)
			},
			image: [],
		}

		if (_.size(item.elementsApperance) > 0) {
			let conditionValue: any = item.value

			if (conditionValue == null || conditionValue == undefined) {
				conditionValue = {}
			}

			item.elementsApperance.forEach((ea: SchemaElementApperance) => {
				if (this.checkCondition(ea, conditionValue)) {
					if (_.size(ea.color) > 0) {
						const color: string = ea.color.trim()
						if (_.size(ea.color) > 0) {
							button.elementAttr = {
								style: 'color: ' + color,
							}
						}
					}

					if (_.size(ea.image) > 0) {
						button.icon = 'data:image/png;base64,' + ea.image
						button.text = ''
					}
				}
			})
		}

		callback(button)
	}

	private drawSchema(): void {
		setTimeout(() => {
			if (_.size(this.$scope.schemaModel.schemaConfiguration) > 0) {
				this.$scope.schemaModel.schemaConfiguration.forEach((sc: SchemaElement) => {
					this.addToForm(sc)
				})
			}

			this.form.promise().then((form) => {
				this.$scope.isLoaded = true
				this.resize()
			})
		})
	}

	private updateSchema(schema: SchemaModel): void {
		this.$scope.schemaModel = schema

		if (this.$scope.schemaModel != null && _.size(this.$scope.schemaModel.schema) > 0) {
			if (this.$scope.schemaModel.height == 0 || this.$scope.schemaModel.width == 0) {
				this.getImageSize(this.$scope.schemaModel.schema).then(() => {
					this.drawSchema()
				})
			} else {
				setTimeout(() => {
					this.updateScale(this.$scope.schemaModel.height, this.$scope.schemaModel.width)
					this.drawSchema()
				})
			}
		} else {
			this.$scope.isLoaded = true
		}
	}

	private loadSchema(): void {
		this.$scope.isLoaded = false

		if (this.$scope.source.id > 0) {
			this.api.location.getSchema(this.$scope.source.id).then((result: SchemaModel) => {
				this.updateSchema(result)
			})
		} else if (this.$scope.source.data != null) {
			this.updateSchema(this.$scope.source.data)
		}
	}

	private getUnits(): JQueryPromise<Dictionary<IReferenceType>> {
		return this.userSession
			.getDataProvider()
			.System.getDictionaries([Enums.ReferenceType.IdUnit])
			.then((dict: Dictionary<Dictionary<IReferenceType>>) => {
				let unitDict: Dictionary<IReferenceType> = new Dictionary([])

				if (dict.containsKey(Enums.ReferenceType.IdUnit)) {
					unitDict = dict.tryGetValue(Enums.ReferenceType.IdUnit)
				}

				return unitDict
			})
	}

	private gotoAction(item): void {
		if (item != null) {
			this.$scope.$root.$broadcast(EventsNames.OPEN_TARGET, item.value, this.$scope.schemaOwner)
		}
	}

	//#endregion
}
